// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pc8e","bordered":"styles_bordered__3U-yd"};